// @generated by protoc-gen-es v2.2.3 with parameter "target=ts,import_extension=none"
// @generated from file v1/common/location.proto (package api.v1.common, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv1";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv1";
import type { LatLng } from "../../google/type/latlng_pb";
import { file_google_type_latlng } from "../../google/type/latlng_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file v1/common/location.proto.
 */
export const file_v1_common_location: GenFile = /*@__PURE__*/
  fileDesc("Chh2MS9jb21tb24vbG9jYXRpb24ucHJvdG8SDWFwaS52MS5jb21tb24igQEKE1BoeXNpY2FsQWRkcmVzc0RhdGESKAoLY29vcmRpbmF0ZXMYASABKAsyEy5nb29nbGUudHlwZS5MYXRMbmcSEAoIcGxhY2VfaWQYAiABKAkSEwoLcG9zdGFsX2NvZGUYAyABKAkSGQoRZm9ybWF0dGVkX2FkZHJlc3MYBCABKAkibAoZU2VydmljZUFyZWFQb3N0YWxDb2RlRGF0YRITCgtwb3N0YWxfY29kZRgBIAEoCRIoCgtjb29yZGluYXRlcxgCIAEoCzITLmdvb2dsZS50eXBlLkxhdExuZxIQCghwbGFjZV9pZBgDIAEoCSKSAQoPU2VydmljZUFyZWFEYXRhEkIKEHBvc3RhbF9jb2RlX2RhdGEYASABKAsyKC5hcGkudjEuY29tbW9uLlNlcnZpY2VBcmVhUG9zdGFsQ29kZURhdGESEQoJcmFkaXVzX2ttGAIgASgFEhgKC2Rlc2NyaXB0aW9uGAMgASgJSACIAQFCDgoMX2Rlc2NyaXB0aW9uQr4BChFjb20uYXBpLnYxLmNvbW1vbkINTG9jYXRpb25Qcm90b1ABWkRnaXRodWIuY29tL2R3YXluZWxhdm9uL2xvY2FsLWNvbW11bml0eS1wbGF0Zm9ybS9hcGkvZ2VuL2dvL3YxL2NvbW1vbqICA0FWQ6oCDUFwaS5WMS5Db21tb27KAg1BcGlcVjFcQ29tbW9u4gIZQXBpXFYxXENvbW1vblxHUEJNZXRhZGF0YeoCD0FwaTo6VjE6OkNvbW1vbmIGcHJvdG8z", [file_google_type_latlng]);

/**
 * @generated from message api.v1.common.PhysicalAddressData
 */
export type PhysicalAddressData = Message<"api.v1.common.PhysicalAddressData"> & {
  /**
   * @generated from field: google.type.LatLng coordinates = 1;
   */
  coordinates?: LatLng;

  /**
   * @generated from field: string place_id = 2;
   */
  placeId: string;

  /**
   * @generated from field: string postal_code = 3;
   */
  postalCode: string;

  /**
   * @generated from field: string formatted_address = 4;
   */
  formattedAddress: string;
};

/**
 * Describes the message api.v1.common.PhysicalAddressData.
 * Use `create(PhysicalAddressDataSchema)` to create a new message.
 */
export const PhysicalAddressDataSchema: GenMessage<PhysicalAddressData> = /*@__PURE__*/
  messageDesc(file_v1_common_location, 0);

/**
 * @generated from message api.v1.common.ServiceAreaPostalCodeData
 */
export type ServiceAreaPostalCodeData = Message<"api.v1.common.ServiceAreaPostalCodeData"> & {
  /**
   * @generated from field: string postal_code = 1;
   */
  postalCode: string;

  /**
   * @generated from field: google.type.LatLng coordinates = 2;
   */
  coordinates?: LatLng;

  /**
   * @generated from field: string place_id = 3;
   */
  placeId: string;
};

/**
 * Describes the message api.v1.common.ServiceAreaPostalCodeData.
 * Use `create(ServiceAreaPostalCodeDataSchema)` to create a new message.
 */
export const ServiceAreaPostalCodeDataSchema: GenMessage<ServiceAreaPostalCodeData> = /*@__PURE__*/
  messageDesc(file_v1_common_location, 1);

/**
 * @generated from message api.v1.common.ServiceAreaData
 */
export type ServiceAreaData = Message<"api.v1.common.ServiceAreaData"> & {
  /**
   * @generated from field: api.v1.common.ServiceAreaPostalCodeData postal_code_data = 1;
   */
  postalCodeData?: ServiceAreaPostalCodeData;

  /**
   * Required for service area
   *
   * @generated from field: int32 radius_km = 2;
   */
  radiusKm: number;

  /**
   * Optional service area description
   *
   * @generated from field: optional string description = 3;
   */
  description?: string;
};

/**
 * Describes the message api.v1.common.ServiceAreaData.
 * Use `create(ServiceAreaDataSchema)` to create a new message.
 */
export const ServiceAreaDataSchema: GenMessage<ServiceAreaData> = /*@__PURE__*/
  messageDesc(file_v1_common_location, 2);

